import { ProgressDropdownWithService } from '../Components/ProgressDropdownWithService';

export default {
  progressDropdownWithServiceComponent: ProgressDropdownWithService,
};
